import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

import './PageError.sass';

export default function PageError({
  children,
  description,
  title,
  onClick = () => {}
}) {
  return (
    <Box
      style={{ pointerEvents: 'all' }}
      className="page-error"
      bgcolor="background.paper"
    >
      <SearchIcon className="page-error-icon" color="disabled" />
      <Typography gutterBottom variant="h6">
        {title}
      </Typography>
      {description && (
        <>
          <Typography gutterBottom variant="body2">
            {description}
          </Typography>
        </>
      )}
      <Button
        sx={{ mt: 2 }}
        variant="contained"
        color="primary"
        onClick={onClick}
        className="page-error-button"
      >
        Ok
      </Button>
      {children}
    </Box>
  );
}
